import { HttpClient, HttpHeaders } from '@angular/common/http';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { WidgetAuthErrorEnum } from './models/widget-auth-error.enum';
import { UserAnalyticModel } from './models/user-analytic.model';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var formHeaders = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8'
    })
};
var WidgetAnalyticsService = /** @class */ (function () {
    function WidgetAnalyticsService(http) {
        this.http = http;
    }
    /**
     * Validates the specified analytic id.
     */
    WidgetAnalyticsService.prototype.getAnalytic = function (analyticId) {
        var _this = this;
        return this.http.get("/ws/user/analytics?analytic_id=" + analyticId)
            .pipe(map(function () { return ({ success: true }); }), catchError(function (response) { return of(_this.parseError(response)); }));
    };
    /**
     * Sends an analytic and return the validation status.
     */
    WidgetAnalyticsService.prototype.sendAnalytic = function (analytic) {
        var _this = this;
        var request$ = analytic instanceof UserAnalyticModel
            // user analytic
            ? this.http.post("/ws/user/analytics", analytic, formHeaders)
            // developer analytic
            : this.http.post("/ws/developer/apps/access/key", analytic, formHeaders);
        return request$
            .pipe(map(function () { return ({ success: true }); }), catchError(function (response) { return of(_this.parseError(response)); }));
    };
    WidgetAnalyticsService.prototype.parseError = function (response) {
        var error = response.error.error;
        var status = response.status;
        // server error isn't an auth failure
        var success = status >= 500 && status <= 504;
        var message = error && error.message ? error.message : '';
        var errorCode = Object.values(WidgetAuthErrorEnum).includes(message) ? message : null;
        return { success: success, message: message, errorCode: errorCode };
    };
    WidgetAnalyticsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function WidgetAnalyticsService_Factory() { return new WidgetAnalyticsService(i0.ɵɵinject(i1.HttpClient)); }, token: WidgetAnalyticsService, providedIn: "root" });
    return WidgetAnalyticsService;
}());
export { WidgetAnalyticsService };
